import { css } from '@emotion/react'
import { ExternalStyles } from 'bold-ui'

export function ConsultaSeguimentoPinDown({ style }: Readonly<{ style?: ExternalStyles }>) {
  return (
    <svg width='12' height='40' viewBox='0 0 12 40' fill='none' xmlns='http://www.w3.org/2000/svg' css={css(style)}>
      <path
        d='M7 28.084C9.83763 28.5601 12 31.0271 12 34C12 37.3137 9.31371 40 6 40C2.68629 40 0 37.3137 0 34C0 31.0271 2.16237 28.5601 5 28.084V0H7V28.084Z'
        fill='currentColor'
      />
    </svg>
  )
}
